import React, { useState } from "react";
import { Avatar, Button } from "@material-ui/core";
import "../Posts/PostsStyle/QuestionPost.css";
import AnswersList from "./AnswersList";
import AnswerPostModal from "./AnswerPostModal";

function Post({
  answers,
  questionId,
  question,
  timestamp,
  buildFaastUser,
  category,
}) {
  const [openModal, setOpenModal] = useState(false);

  const defaultProps = {
    bgcolor: "background.paper",
    borderColor: "text.primary",
    m: 1,
    border: 1,
  };

  return (
    <div className="post">
      <div className="post__info">
        <Avatar src={buildFaastUser ? buildFaastUser.photo : Avatar} />
        <h5>
          {buildFaastUser.displayName
            ? buildFaastUser.displayName
            : buildFaastUser.email}
        </h5>
        <small>{new Date(timestamp?.toDate()).toLocaleString()}</small>
        <small>{category}</small>
      </div>

      <div className="post__body">
        <div className="post__question">
          <p>{question}</p>
          <AnswerPostModal
            questionId={questionId}
            question={question}
            timestamp={timestamp}
            buildFaastUser={buildFaastUser}
            openModal={openModal}
            setOpenModal={setOpenModal}
          />
        </div>

        <div className="post__answer">
          <AnswersList answers={answers} questionId={questionId} />
        </div>
      </div>

      <div className="post__questionAnswer">
        <Button onClick={() => setOpenModal(true)} className="post__btnAnswer">
          Answer
        </Button>
      </div>
    </div>
  );
}

export default Post;
